"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _FileManager = _interopRequireDefault(require("composer-lib/components/shared/FileManager"));

var _Drawer = _interopRequireDefault(require("FileManagerLib/components/Drawer"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SmallToggleButton = _interopRequireDefault(require("draft-plugins/components/SmallToggleButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _userInfo = require("hub-http/userInfo");

var AddImageButton = (0, _createReactClass.default)({
  displayName: "AddImageButton",
  propTypes: {
    fileManagerUploadedFileAccess: _propTypes.default.string.isRequired,
    onChange: _propTypes.default.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      open: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var fileManagerUploadedFileAccess = this.props.fileManagerUploadedFileAccess;
    this.FileManager = (0, _FileManager.default)(fileManagerUploadedFileAccess, (0, _UsageTracking.getUsageTracker)());
  },
  handleClick: function handleClick() {
    (0, _UsageTracking.trackEvent)({
      action: "format-bar-click",
      extra: {
        'click-type': 'image'
      },
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
    });
    this.setState({
      open: true
    });
  },
  handleClose: function handleClose(e) {
    if (e) {
      e.stopPropagation();
    }

    this.setState({
      open: false
    });
  },
  handleInsert: function handleInsert(file) {
    var onChange = this.props.onChange;
    this.setState({
      open: false
    });
    onChange({
      src: file.get('url'),
      name: file.get('name')
    });
  },
  renderFileManager: function renderFileManager(open) {
    if (!open) {
      return null;
    }

    return _react.default.createElement(this.FileManager, {
      auth: (0, _userInfo.userInfoSync)()
    }, _react.default.createElement(_Drawer.default, {
      onSelect: this.handleInsert,
      onClose: this.handleClose
    }));
  },
  render: function render() {
    var open = this.state.open;
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_SmallToggleButton.default, {
      active: open,
      className: "image-button",
      icon: "insertImage",
      onClick: this.handleClick,
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-lib.insertTools.image"
      })
    }), _react.default.createElement("div", {
      style: {
        display: 'none'
      }
    }, this.renderFileManager(open)));
  }
});
var _default = AddImageButton;
exports.default = _default;
module.exports = exports.default;